import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../common/namespace-classes';
var ModalFooter = /** @class */ (function (_super) {
    __extends(ModalFooter, _super);
    function ModalFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalFooter.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames('modal-footer', props.className);
        return (React.createElement("div", { className: classNames }, props.children));
    };
    return ModalFooter;
}(React.PureComponent));
export { ModalFooter };
//# sourceMappingURL=modal-footer.js.map